import { IPreOffer, IPreOfferApproved } from "../interfaces/preOffer.interface";

export const isApprovedPreOffer = (
  preOffer: IPreOffer
): preOffer is IPreOfferApproved =>
  preOffer.status === "approved" &&
  preOffer.scoring.approvedByTier === true;

export const isExpiredPreOffer = (
  preOffer: IPreOffer
): boolean =>
  preOffer.status === "expired" &&
  preOffer.scoring.approvedByTier === true;

export const getLatestPreOffer = (
  preOffers?: IPreOffer[]
): IPreOffer | undefined => {
  if (!preOffers?.length) return undefined;

  return preOffers.reduce((latest, current) =>
    new Date(current.createdAt) > new Date(latest.createdAt) ? current : latest
  );
};
